// App
import React, { useEffect, useRef, ReactNode } from 'react';
import ReactDOM from 'react-dom';

// Misc / utils
import appUtils from 'app/shared/utils/appUtils';
import * as S from './styles';

type MapViewProps = {
  ariaLabel: string;
  children: ReactNode;
  dropdownId: string;
  onClose: () => void;
  modalRef?: React.RefObject<HTMLDivElement>;
  isVisible: boolean;
};

const MapView = ({ ariaLabel, children, dropdownId, onClose, modalRef, isVisible }: MapViewProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.focus();
    }

    if (isVisible) {
      appUtils.lockVerticalScrolling({ isForPortal: true });
    } else {
      appUtils.unlockVerticalScrolling();
    }
  }, [isVisible]);

  // Esc key will close filter modal
  const handleOnKeyDown = (e: React.KeyboardEvent) => {
    return e.keyCode === 27 && onClose();
  };

  return ReactDOM.createPortal(
    <S.Overlay
      id={dropdownId}
      role="dialog"
      aria-label={ariaLabel}
      aria-modal="true"
      tabIndex={-1}
      onKeyDown={handleOnKeyDown}
      isVisible={isVisible}
      ref={modalRef}
    >
      {children}
    </S.Overlay>,
    document.getElementById('modal-root') as Element,
  );
};

export default MapView;
